module.exports = __webpack_public_path__ + "static/media/folder.87079e6a.svg";